import { requestYfd } from './request'

export function fetchTrainList(srId) {
  return requestYfd(
    `/ep-garden-user-feedback/api/training/feedback/${srId}/trainings`,
  )
}
export function updateFeedback(srId, trainingId, registerPhone) {
  return requestYfd(
    `/ep-garden-user-feedback/api/training/feedback/${srId}?trainingId=${trainingId}&registerPhone=${registerPhone}`,
    {
      method: 'post',
    },
  )
}
